import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[580px] overflow-hidden" aria-label="头条热点">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20bold%20modern%20entertainment%20news%20studio%20background%20with%20dramatic%20warm%20red%20and%20orange%20gradient%20lighting%2C%20abstract%20geometric%20shapes%2C%20newsroom%20vibe%2C%20dynamic%20and%20energetic%20atmosphere%2C%20professional%20broadcast%20studio%20with%20soft%20glowing%20accents%2C%20dark%20rich%20background%20with%20vibrant%20highlights&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="吃瓜网头条热点背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55"></div>
      </div>
      <div className="absolute inset-0 flex items-center">
        <div className="w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/90 text-background-50 text-xs font-semibold mb-6 whitespace-nowrap">
            <i className="ri-flashlight-line"></i>
            <span>爆炸新闻</span>
          </div>
          <h1 className="text-3xl md:text-5xl font-bold text-background-50 mb-4 leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
            娱乐圈最劲爆的瓜<br className="hidden sm:block" />
            都在这里等你来吃
          </h1>
          <p className="text-background-50/80 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
            每日更新最新娱乐八卦、明星动态、热门事件追踪，独家爆料不停歇，畅快吃瓜不等待
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/mingxing-bagua"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full transition-all duration-200 whitespace-nowrap text-sm cursor-pointer"
            >
              立即吃瓜
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/category/dujia-mengliao"
              className="px-8 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-semibold rounded-full backdrop-blur-sm transition-all duration-200 whitespace-nowrap text-sm cursor-pointer border border-background-50/20"
            >
              独家猛料
              <i className="ri-spy-line ml-2"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}